import { Component, OnInit, Input } from '@angular/core';
import { SearchService } from '../../search.service';
import { SearchFilterComponent } from '../search-filter.component';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { DatePickerConfigService } from '../../../components/datepicker/datepicker-config.service';
import { Condition } from '../../models/search-filter-model';

@Component({
  selector: 'lfwms-search-filter-condition',
  templateUrl: './search-filter-condition.component.html',
  styleUrls: ['./search-filter-condition.component.css']
})
export class SearchFilterConditionComponent implements OnInit {

  @Input() condition: Condition;
  @Input() index: number;
  @Input() searchService: SearchService;
  @Input() filterComponent: SearchFilterComponent;

  public alertService: AlertService;

  constructor(private resourceService: ResourceService, private dateConfigService: DatePickerConfigService) { }

  ngOnInit() {
    /* to display type as string instead of numeric value in lookup's for user understanding [ex: 1 - storer]
       when loading lookup search filter condition */
    this.filterComponent.getType();
    this.alertService = this.searchService.searchParams.alertService;
  }

  // method for applying a particular condition
  public applyCondition(applyCondition: any) {
    try {
      if (!applyCondition.isMandatory) {
        this.filterComponent.rebuildSearchCriteria();
        this.alertService.clearAll();
      }
    } catch (error) {
      this.alertService.clearAll();
      this.alertService.error(this.resourceService.get(error.message));
      return false;
    }

    this.searchService.getSearchCriteria().conditions.forEach((condition) => {
      // converting the format of date type values
      condition.clauses.forEach(clause => {
        const type = this.filterComponent.metaDataMap[clause.column].type;
        /*Start: Code changes for between operator */
        if (clause.operation === 'between') {
          if ((type === 'DATE' || type === 'DATETIME') && clause.value && clause.value1) {
               clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
               clause.formattedDateValue1 = this.filterComponent.formatDate(clause.value1, type);
          }
          if (condition.isMandatory && clause.value === '' && clause.value1 === '') {
            clause.value = '*';
            clause.value1 = '*';
          }
          /*End: Code changes for between operator */
        } else {
          if ((type === 'DATE' || type === 'DATETIME') && clause.value) {
              clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
          }
          if (condition.isMandatory && clause.value === '') {
              clause.value = '*';
            }
          let lookupColumnList: {[key: string]: string} = {
            carrierType: '3',
            sellerType: '5',
            storerType: '2'
          }
          if(Object.keys(lookupColumnList).includes(clause.column)){
            if (clause.value === '*') {
              // this scenario should be handled in backend. it's a temproary fix
              clause.value = lookupColumnList[clause.column];
            }
            this.filterComponent.getType();
          }
         }
      });
      if (condition.displayMode === 'EDIT') {
        condition.displayMode = 'VIEW';
      }
    });
    this.condition.displayMode = 'VIEW';
  }

  // method for editing a particular condition
  public editCondition(applyCondition) {
    try {
      if (!applyCondition.isMandatory) {
        this.filterComponent.rebuildSearchCriteria();
        this.alertService.clearAll();
      }
    } catch (error) {
      // JIRA LFWM-1329 Fixes - On editing incomplete Search condition, error message shown
      if (applyCondition.displayMode === 'VIEW') {
        applyCondition.displayMode = 'EDIT';
      } else if (applyCondition.displayMode === 'EDIT') {
        this.alertService.clearAll();
        this.alertService.error(this.resourceService.get(error.message));
        return false;
      }
    }

    this.searchService.getSearchCriteria().conditions.forEach(condition => {
      if (condition.id === applyCondition.id) {
        condition.displayMode = 'EDIT';
        // calling the below method so as to load the correct field type for entering values during the edit mode
        condition.clauses.forEach((clause, index) => {
          this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[clause.column].type, index);
        });
      } else {
        condition.displayMode = 'VIEW';
      }
    });
  }

  // method for deleting a particular condition
  public deleteCondition(conditionId) {
    this.filterComponent.deleteCondition(conditionId, this.index);
  }

  // method for clear all condition
  public clearAllCondition(condition) {
    //Removing duplicate column clauses.
    let clauseCols = [];
    condition.clauses = condition.clauses.filter(clause=>{
      if(!clauseCols.includes(clause.column)){
        clauseCols.push(clause.column);
        return true;
      }
      return false;
    });
    condition.clauses.forEach((clause) => {
      // get the column metadata
      const column = this.filterComponent.metaDataMap[clause.column];
      // if this is a column of type Object, '*' does not apply here.
      // Instead set the first value
      if (column.dataType === 'Object' && column.isMandatory) {
        const options = this.filterComponent.getOptionsForProperty(clause.column);
        if (options && options.length > 0) {
          clause.value = options[0].key;
          // filterComponent.type is the value visible after selecting a dropdown in view mode
          this.filterComponent.type = options[0].value;
          // setting tableid on change of dropdown in searchparms
          this.searchService.searchParams.tableId = options[0].key;
        }
      } else {
        if (condition.displayMode === 'VIEW') {
          clause.value = '*';
          clause.value1 = '*';
        } else {
          clause.value = '';
          clause.value1 = '';
        }
        this.filterComponent.setDefaultDropdownValues(clause);
      }
    });
  }

  asJson(v) {
    return JSON.stringify(v);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/filter/search-filter-condition/search-filter-condition.component.ts